<template>
  <div class="welcomeBox">
    <!-- Infinity -->
    <vue-typer
      erase-style="select-all"
      caret-animation="expand"
      initial-action="typing"
      :text="vueTyperText"
      :repeat="Infinity"
      :shuffle="false"
      :pre-type-delay="36"
      :type-delay="100"
      :pre-erase-delay="2000"
      :erase-delay="500"
      :erase-on-complete="false"
    ></vue-typer>
  </div>
</template>

<script>
import { sysConfig } from "@/api/apifoxInterface";

export default {
  name: "welcomeBox",
  components: {},
  props: {},
  data() {
    return {
      vueTyperText: [],
      helpSysConfig: require("@/lib/json/apifox/sysConfig.json"),
    };
  },
  methods: {
    getSysConfig() {
      sysConfig().then((res) => {
        if (res.data.code === 200) {
          this.vueTyperText = [];
          this.vueTyperText = [
            res.data.data.welcomeText,
            `作者：${res.data.data.author}`,
            // `笔名：${res.data.data.penName}`,
          ];
        }

        if (res.data.code === 504) {
          /* 网络错误，使用本地数据 */
          this.vueTyperText = [];
          this.vueTyperText = [
            this.helpSysConfig.data.welcomeText,
            `作者：${this.helpSysConfig.data.author}`,
          ];
        }
      });
    },
  },
  created() {
    this.getSysConfig();
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.welcomeBox {
  font-size: 50px;
  text-align: center;
  line-height: 100px;
  letter-spacing: 10px;
}

::v-deep .typed {
  /*background: linear-gradient(to right, rgba(255, 0, 0, 0.97), orange, yellow, green, blue) !important;*/
  /*background-clip: text !important;*/
  /*-webkit-background-clip: text !important;*/
  /*color: transparent !important;*/

  color: #ffffff !important;
  animation: glitter 1s infinite !important;
}

::v-deep .selected {
  background-color: #c5b1f6 !important;
  color: white !important;
}

@keyframes glitter {
  0% {
    opacity: 0.5;
    text-shadow: none;
  }
  50% {
    opacity: 1;
    text-shadow: 0 0 10px rgba(255, 255, 255, 0.8);
  }
  100% {
    opacity: 0.5;
    text-shadow: none;
  }
}
</style>
